import React from 'react';
import { Select, Button } from 'antd';

const { Option } = Select;

/**
 * Component that is used to filter resources in a live schedule that a scheduler wants to view.
 */
class WorkerMultiSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            workers: this.props.workers,
            filteredArray: []
        };
        this.handleChange = this.handleChange.bind(this);
    }

    /**
     * Updates the filtered array list every time a scheduler adds or subtracts a resource.
     */
    handleChange = (event) => {
        let tempFilteredArray = this.state.filteredArray;
        if (tempFilteredArray.length === 0) {
            for (let resourceString of event) {
                for (let worker of this.state.workers) {
                    if (worker.title === resourceString) {
                        tempFilteredArray.push(worker);
                        break;
                    }
                }
            }
        } else if (event.length > tempFilteredArray.length) {
            for (let resourceString of event) {
                for (let worker of this.state.workers) {
                    if (worker.title === resourceString) {
                        let isInFilteredArray = false;
                        for (let filteredWorker of tempFilteredArray) {
                            if (worker.title === filteredWorker.title) {
                                isInFilteredArray = true;
                                break;
                            }
                        }
                        if (!isInFilteredArray) {
                            tempFilteredArray.push(worker);
                            break;
                        }
                    }
                }
            }
        } else {
            if (event.length === 0) {
                tempFilteredArray = [];
            } else {
                let count = 0;
                for (let filteredWorker of tempFilteredArray) {
                    let isInEventArray = false;
                    for (let resourceString of event) {
                        if (filteredWorker.title === resourceString) {
                            isInEventArray = true;
                            break;
                        }
                    }
                    if (!isInEventArray) {
                        tempFilteredArray.splice(count, 1);
                    }
                    count++;
                }
            }
        }
        this.setState({
            filteredArray: tempFilteredArray
        }, ()=> {
            this.props.returnFilteredArray(this.state.filteredArray)
        })
    }

    render() {
        const padding = '\xa0';
        return(
            <div>
                <Select
                    mode="multiple"
                    style={{ width: '100%' }}
                    placeholder={`${padding}Select a worker`}
                    onChange={this.handleChange}
                    allowClear="true"
                >
                    {
                        this.state.workers.length > 0 ?
                        this.state.workers.map(worker => (
                            <Option key={worker.id} value={worker.title}>{worker.title}</Option>
                        )) : null
                    }
                </Select>
                <br />
                <br />
            </div>
        );
    }
}

export default WorkerMultiSelect;
